<nwm-menu />
<div class="main content">
  <div class="row no-gutters py-4">
    <div class="col-xxl-10 offset-xxl-1">
      <div class="h2-text mt-4">Calendar Year Returns As Of {{valuationDate | date:'MMMM d, yyyy'}}</div>
      <div class="card chart-block">
        <div class="card-body p-3" style="overflow: auto">
          <div style="min-width:500px">
            <CYRChart [plan]="plan" />
          </div>
        </div>
      </div>
      <br />
      <div class="h2-text mt-4">Returns by Year As Of {{valuationDate | date:'MMMM d, yyyy'}}</div>
      @if (data.length > 0) {
        <div class="scrollable-wrap">
          <div class="scrollable">
            <div class="scrollable-button left"></div>
            <div class="scrollable-button"></div>
            <table width="100%" class="NWMtable sticky_header table-hover">
              <thead>
                <tr class="section-header">
                  <th class="td-period" style="text-align: left">Period Ending</th>
                  <th class="td-mv" align="right">Market Value&nbsp;($)</th>
                  <th class="td-ai" align="right">Amount Invested<br />During Year&nbsp;($)</th>
                  <th class="td-tai" align="right">Amount Invested<br />Since Inception&nbsp;($)</th>
                  <th class="td-arsi" align="right">Annualized Return<br />Since Inception</th>
                  <th class="td-cytdr" align="right">YTD Return</th>
                </tr>
              </thead>
              <tbody>
                @for (item of data; track item) {
                  <tr>
                    <td class="td-period">{{item.ValuationDate}}</td>
                    <td class="td-mv" align="right">{{item.MarketValue | number:'1.0-0' |minusSignToParens | placeholder:'-'}}</td>
                    <td class="td-ai" align="right">{{item.YtdActivity | number:'1.0-0' |minusSignToParens | placeholder:'-'}}</td>
                    <td class="td-tai" align="right">{{item.InceptionActivity | number:'1.0-0' |minusSignToParens | placeholder:'-'}}</td>
                    <td class="td-arsi" align="right">{{item.InceptionReturn}}</td>
                    <td class="td-cytdr" align="right">{{item.YtdReturn}}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      @if (plan==='' && !isPershing) {
        <span class="pull-right" style="font-size: smaller;">*All values are in CAD</span>
      }
      @if (isPershing) {
        <span class="pull-right" style="font-size: smaller;">*All values are in USD</span>
      }
    </div>
  </div>
</div>
